import qs from 'qs';

import { proxyApi } from '@/lib/api';
import { retry } from '@/lib/retry';

import type { IObject } from '@/domains/core/core.types';

import type { JiraPriority, JiraProject } from './jira.types';

export const getJiraProjects = async (keys?: string[]) => {
  const res = await retry(() =>
    proxyApi.get<JiraProject[]>('/jira/projects', {
      params: keys?.length ? { keys } : undefined,
      paramsSerializer: (params) => {
        return qs.stringify(params, { arrayFormat: 'repeat', encode: false });
      },
    }),
  );

  return res.data;
};

export const getJiraPriorities = async () => {
  const res = await retry(() => proxyApi.get<JiraPriority[]>('/jira/priorities'));
  return res.data;
};

export const createJiraIssue = async (data: IObject) => {
  const res = await retry(() =>
    proxyApi.post<{
      self: string;
      key: string;
    }>('/jira/create-issue', data),
  );

  return res.data;
};
